// ELASTIC KEYS
export const patientInfoElasticList = [
    {
        key: 'firstName',
        label: 'First Name',
    },
    {
        key: 'lastName',
        label: 'Last Name',
    },
    {
        key: 'email',
        label: 'Email',
    },
    {
        key: 'dob',
        label: 'Date Of Birth',
    },
    {
        key: 'gender',
        label: 'Gender',
    },
    {
        key: 'userCode',
        label: 'User Code',
    },
]

export const patientAdditionalInfoElasticList = [
    {
        key: 'identityWithHeldReason',
        label: 'Identity With Held Reason',
    },
    {
        key: 'occupation',
        label: 'Occupation',
    },
    {
        key: 'maritalStatus',
        label: 'Marital Status',
    },
    {
        key: 'religion',
        label: 'Religion',
    },
    {
        key: 'accommodationStatus',
        label: 'Accommodation Status',
    },
    {
        key: 'diagnostic',
        label: 'Diagnostic',
    },
]

export const patientAddressInfoElasticList = [
    {
        key: 'addressLine1',
        label: 'Address Line 1',
    },
    {
        key: 'addressLine2',
        label: 'Address Line 2',
    },
    {
        key: 'addressLine3',
        label: 'Address Line 3',
    },
    {
        key: 'addressLine4',
        label: 'Address Line 4',
    },
    {
        key: 'city',
        label: 'City',
    },
    {
        key: 'state',
        label: 'State',
    },
    {
        key: 'country',
        label: 'Country',
    },
    {
        key: 'postalCode',
        label: 'Postal Code',
    },
    {
        key: 'phone',
        label: 'Phone Number',
    },
]

// PATIENT
export const basicPatientInfo = [
    {
        key: 'gender',
        label: 'Gender',
    },
    {
        key: 'userCode',
        label: 'User Code',
    },
]

export const basicPatientAdditionalInfo = [
    {
        key: 'IdentityWithHeldReason',
        label: 'Identity With Held Reason',
    },
    {
        key: 'occupation',
        label: 'Occupation',
    },
    {
        key: 'maritalStatus',
        label: 'Marital Status',
    },
    {
        key: 'religion',
        label: 'Religion',
    },
    {
        key: 'accommodationStatus',
        label: 'Accommodation Status',
    },
    {
        key: 'diagnostic',
        label: 'Diagnostic',
    },
    {
        key: 'currentLocation',
        label: 'Current Location',
    },
]

export const basicPatientAddressInfo = [
    {
        key: 'addressLine1',
        label: 'Address Line 1',
    },
    {
        key: 'addressLine2',
        label: 'Address Line 2',
    },
    {
        key: 'addressLine3',
        label: 'Address Line 3',
    },
    {
        key: 'addressLine4',
        label: 'Address Line 4',
    },
    {
        key: 'city',
        label: 'City',
    },
    {
        key: 'state',
        label: 'State',
    },
    {
        key: 'country',
        label: 'Country',
    },
    {
        key: 'postalCode',
        label: 'Postal Code',
    },
    {
        key: 'phone',
        label: 'Phone Number',
    },
]

export const basicPatientGeneralPractitioner = [
    {
        key: 'name',
        label: 'GP Name',
    },
    {
        key: 'email',
        label: 'GP Email',
    },
    {
        key: 'surgery',
        label: 'GP Surgery',
    },
    {
        key: 'type',
        label: 'Address Type',
    },
    {
        key: 'addressLine1',
        label: 'Address Line 1',
    },
    {
        key: 'addressLine2',
        label: 'Address Line 2',
    },
    {
        key: 'addressLine3',
        label: 'Address Line 3',
    },
    {
        key: 'addressLine4',
        label: 'Address Line 4',
    },
    {
        key: 'city',
        label: 'City',
    },
    {
        key: 'state',
        label: 'State',
    },
    {
        key: 'country',
        label: 'Country',
    },
    {
        key: 'postalCode',
        label: 'Postal Code',
    },
    {
        key: 'phone',
        label: 'Phone Number',
    },
]

// DATALIST
export const basicPatientDataList = {
    basicInformation: basicPatientInfo,
    additionalInfomation: basicPatientAdditionalInfo,
    contactInformation: basicPatientAddressInfo,
    gpInformation: basicPatientGeneralPractitioner,
}

export const elasticPatientDataList = {
    basicInformation: patientInfoElasticList,
    additionalInfomation: patientAdditionalInfoElasticList,
    contactInformation: patientAddressInfoElasticList,
}
